import { render, staticRenderFns } from "./HostDetail.vue?vue&type=template&id=4cc6013c"
import script from "./HostDetail.vue?vue&type=script&lang=js"
export * from "./HostDetail.vue?vue&type=script&lang=js"
import style0 from "./HostDetail.vue?vue&type=style&index=0&id=4cc6013c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports